const zh: Record<string, string> = {
  // General
  'site.name': '桃子视频',
  'site.description': '数字系列视频平台',

  // Navigation
  'nav.home': '首页',
  'nav.categories': '分类浏览',
  'nav.about': '关于我们',
  'nav.search': '搜索视频...',

  // Home page
  'home.hero.badge': '🎯 数字系列视频平台',
  'home.hero.title1': '高清视频',
  'home.hero.title2': '免费看',
  'home.hero.subtitle': '不卡顿 · 不缓冲 · 资源全',
  'home.hero.description': '91视频、97视频、51视频、92视频、98视频、小蓝视频、妖精视频 —— 数字系列视频平台全覆盖，电影电视剧全集免费高清在线观看，极速加载，畅享观影体验',
  'home.hero.cta': '立即观看',
  'home.hero.secondary': '了解更多',
  'home.hero.stat1': '视频资源',
  'home.hero.stat2': '数字系列平台',
  'home.hero.stat3': '月活跃用户',

  // Category section
  'home.category.title': '数字系列视频平台',
  'home.category.description': '七大平台，海量资源，总有一个适合你。点击进入，即刻畅享高清观影体验。',

  // Featured videos
  'home.featured.title': '精选推荐',
  'home.featured.description': '编辑精选，品质保证',
  'home.featured.viewAll': '查看全部',

  // Latest articles
  'home.articles.title': '最新资讯',
  'home.articles.description': '影视动态、行业洞察、观影指南',
  'home.articles.more': '更多文章',

  // Article page
  'article.notFound': '内容不存在',
  'article.related': '相关推荐',
  'article.relatedArticles': '相关文章',

  // Category page
  'category.notFound': '分类不存在',
  'category.noVideos': '该分类暂无视频资源',

  // About page
  'about.title': '关于桃子视频',
  'about.description': '桃子视频是一个聚合型数字系列视频平台，致力于为广大用户提供免费、高清、流畅的在线视频观看体验。',
  'about.brandStory': '品牌故事',
  'about.contactUs': '联系我们',
  'about.testimonials': '用户口碑',
  'about.testimonialsDesc': '听听用户怎么说',
  'about.joinCommunity': '加入我们的观影社区',
  'about.joinDesc': '随时随地，畅享高清影视。桃子视频，让好内容触手可及。',
  'about.cta': '立即体验',

  // Contact form
  'form.name': '您的姓名',
  'form.namePlaceholder': '请输入您的姓名',
  'form.email': '电子邮箱',
  'form.emailPlaceholder': '请输入您的邮箱',
  'form.subject': '主题',
  'form.subjectPlaceholder': '请输入主题',
  'form.message': '留言内容',
  'form.messagePlaceholder': '请输入您的留言（500字以内）',
  'form.submit': '发送留言',
  'form.submitting': '提交中...',
  'form.success': '感谢您的留言，我们会尽快回复！',
  'form.error': '提交失败，请稍后重试',

  // Footer
  'footer.description': '桃子视频🎯数字系列视频平台，91视频、97视频、📌51视频等热门资源免费高清在线看，电视剧电影全集不缓冲。',
  'footer.categories': '视频分类',
  'footer.links': '快捷链接',
  'footer.contact': '联系方式',
  'footer.terms': '用户协议',
  'footer.privacy': '隐私政策',
  'footer.copyright': '© 2024 桃子视频 Taozivideo.com 版权所有',

  // Breadcrumb
  'breadcrumb.home': '首页',
};

export default zh;